import React from "react";
import { motion } from "framer-motion";
import { Map, Home, Info, Shield, HelpCircle, Phone, List } from "lucide-react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Link } from "react-router-dom";

export default function SitemapPage() {
  const sections = [
    {
      title: "Main Pages",
      icon: Home,
      links: [
        { name: "Home", path: "/" },
        { name: "Search", path: "/search" },
        { name: "Post an Item", path: "/post" },
      ]
    },
    {
      title: "Company",
      icon: Info,
      links: [
        { name: "About Us", path: "/about" },
        { name: "Careers", path: "/careers" },
        { name: "Privacy Policy", path: "/privacy" },
        { name: "Terms of Service", path: "/terms" },
      ]
    },
    {
      title: "Support",
      icon: HelpCircle,
      links: [
        { name: "Help Center", path: "/help" },
        { name: "How it works", path: "/how-it-works" },
        { name: "Trust & Safety", path: "/safety" },
        { name: "Selling Tips", path: "/tips" },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Header />

      <main>
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden bg-gray-50 text-center">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-gray-900 via-gray-900 to-green-900/30 -z-10"></div>
          <div className="max-w-7xl mx-auto px-6">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6"
            >
              <Map className="w-8 h-8 text-green-400" />
            </motion.div>
            <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-emerald-400">
              Sitemap
            </h1>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Easily navigate through all the sections of HuluOrder.
            </p>
          </div>
        </section>

        {/* Links Section */}
        <section className="py-24 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {sections.map((section, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="space-y-6"
              >
                <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                  <section.icon className="w-6 h-6 text-green-600" />
                  <h2 className="text-2xl font-bold">{section.title}</h2>
                </div>
                <ul className="space-y-4">
                  {section.links.map((link, j) => (
                    <li key={j}>
                      <Link 
                        to={link.path} 
                        className="text-gray-600 hover:text-green-600 transition-colors flex items-center gap-2 group"
                      >
                        <div className="w-1 h-1 bg-gray-300 rounded-full group-hover:bg-green-500 transition-colors"></div>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
